import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 80%;
    height: 220px;
    max-width: 400px;
    background: white;
    border-radius: 20px;
    margin: 2rem 0rem;
    padding: 0rem 1.5rem;

    .general {
        display: flex;
        flex-direction: column; 
        width: 100%;
        height: 100%;
        padding: 1rem 0rem;
    }

    .box-content {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
    }

    .box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
    .bar {
        position: relative;
        background: #D1D1D1;
        border-radius: 5px;
        height: 65%;
        width: 1.6rem;
    }
    
    .bar-percentage {
        position: absolute;
        bottom: 0;
        background: #FF4704;
        width: 100%;
        border-radius: 5px;
    }
`;
